import {get} from "lodash"
import BaseService from "./Base"

class EnrollmentTargetService extends BaseService {
    async listMeasurements(params = {}) {
        const response = await this.post("/v1/enrollment-targets/measurements/list", params)
        return get(response, "data", [])
    }

    async createMeasurement(params = {}) {
        const response = await this.post("/v1/enrollment-targets/measurements/create", params)
        return get(response, "data.data", {})
    }

    async updateMeasurement(params = {}) {
        const response = await this.post(`/v1/enrollment-targets/measurements/edit`, params)
        return get(response, "data.data", {})
    }

    async deleteMeasurement(params = {}) {
        const response = await this.post("/v1/enrollment-targets/measurements/delete", params)
        return get(response, "data.data", {})
    }

    async listAssignments(params = {}) {
        const response = await this.post("/v1/enrollment-targets/assignments/list", params)
        return get(response, "data", [])
    }

    async createAssignment(params = {}) {
        const response = await this.post("/v1/enrollment-targets/assignments/create", params)
        return get(response, "data.data", {})
    }

    async updateAssignment(params = {}) {
        const response = await this.post("/v1/enrollment-targets/assignments/update", params)
        return get(response, "data.data", {})
    }

    async deleteAssignment(params = {}) {
        const response = await this.post("/v1/enrollment-targets/assignments/delete", params)
        return get(response, "data.data", {})
    }

    async listEnrollmentScorecard(params = {}) {
        const response = await this.post("/v1/enrollment-targets/enrollment-scorecard/list", params)
        return get(response, "data.data", {})
    }
}

export default EnrollmentTargetService
